module.exports = __webpack_public_path__ + "static/media/BulkUploadsTemplate(Config1).04ad5973.xlsx";